import { useEffect, useState } from 'react'
import BigNumber from 'bignumber.js'
import axios from "axios"



const useGetPriceData = () => {
  const [data, setData] = useState<BigNumber>(new BigNumber(0))
  const API_URL = "https://api.dex.guru/v1/tokens/0x0db5ca5Fd5E07E4038273CF5710E06fFcD0fecC0-bsc"


  useEffect(() => {
    const fetchData = async () => {
      const resp = await axios.get(API_URL);
      // axios.get(API_URL).then((re)=>{
      //   setCakePriceBusd(new BigNumber(re.data.data.price))
      // });
      console.log(resp.data,"price 22");

      setData(new BigNumber(resp.data.priceUSD))
    }

    fetchData()
  }, [])

  return data
}

export default useGetPriceData